import ExtendableObject from "./ExtendableObject";

const Tool = ExtendableObject.extend({
  constructor(editor) {
    this.editor = editor;
    this.prevZzoom = 1;
    this.prevX = 0;
    this.prevY = 0;
  },

  open() {},

  enter() {},

  leave() {},

  send() {},

  pointerDown(x, y) {},

  dragStart(x, y) {
    this.prevX = x;
    this.prevY = y;
  },

  dragMove(x, y) {
    this.editor.pan(x - this.prevX, y - this.prevY);
    this.prevX = x;
    this.prevY = y;
  },

  dragEnd(x, y) {},

  pinchStart(x, y) {
    this.prevZzoom = 1;
  },

  pinchMove(dist, x, y) {
    const coeff = dist / this.prevZzoom;
    this.prevZzoom = dist;
    this.editor.zoom(x, y, coeff);
  },

  pinchEnd(x, y) {},

  mouseWheel(x, y, delta) {
    const amt = delta > 0 ? -1 : delta < 0 ? 1 : 0;
    let coeff = Math.pow(1.1, amt); // TODO: constants to opts
    this.editor.zoom(x, y, coeff);
  },

  selectionAction() {},

  bindEvents(el, activate) {}
});

export default Tool;
